'use strict';
angular.module('cvsApp').factory('retrieveFormOfPaymentModel', ['commonModel',function(CM) {	
	
	var retrieveFormOfPaymentModel = function(){
		
		var self = this;

		self.apiResponse = {};
		
		this.setResponse = function(data){
			CM.setResponse(data);			
		}	

		this.getResponse = function(data){
			self.apiResponse = CM.getResponse();
			self.header = CM.getHeader();	
			return self;		
		}	

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(self.apiResponse.showError){	
				return self.apiResponse.showError;
			}
			return "";
		}
		this.getHeader = function () {
            return self.header;
        }

		this.getPaymentInfos =function (){
			var paymentInfo = [];
			if(!self.apiResponse.showError && self.apiResponse.paymentInfo != undefined && self.apiResponse.hasOwnProperty('paymentInfo') && self.apiResponse.paymentInfo != '')			
				if(_.isArray(self.apiResponse.paymentInfo.paymentDetails)){
					return self.apiResponse.paymentInfo.paymentDetails;
				}else{
					paymentInfo.push(self.apiResponse.paymentInfo.paymentDetails);
					return paymentInfo;
				}
			return paymentInfo;			
		}
		
		this.getActivePaymentInfo = function(){
			var activePayMethod = [];
			var paymentInfo = this.getPaymentInfos();
			for(var i=0; i < paymentInfo.length; i++){
				if(paymentInfo[i].activeFlag == "ACTIVE"){
					activePayMethod.push(paymentInfo[i]);
				}
			}
			
			return activePayMethod;
		}
	
	}
	
	return new retrieveFormOfPaymentModel();
}]);